import constructActionTypes from 'common/utils/constructActionTypes';

module.exports = constructActionTypes(
    {
        SET_FORM_ID: null,
        LOADED_FORM_DATA: null,
        SET_UPLOAD_URL: null,
        SET_SUBMIT_URL: null,
        SET_EVENT_ID: null,
        SET_FORM_INITIAL_STATE: null,
        SET_FORM_IS_UPDATING: null,
        SET_VIEWER_DATA: null,
        SET_GUEST_ACCESS_HASH: null,
        SET_RSVP_FORM_METADATA: null,
        SET_FORM_SUBMITTING: null,
        UPDATE_FORM_VALUE: null,
        UPDATE_FORM_INITIAL_VALUE: null,
        CLEAR_FORM_GROUPS: null,
        UPDATE_FORM_GROUP_VALUE: null,
        SET_FORM_GROUP_VALUES: null,
        UPDATE_FORM_TOUCHED: null,
        SET_FORM_VALUES: null,
        SET_FORM_ERRORS: null,
        SET_FORM_META: null,
        SET_FORM_METAS: null,
        SET_FORM_NODE_ERROR: null,
        SET_FORM_GROUP_ERRORS: null,
        SET_FORM_TOUCHED: null,
        SET_FIELD_ERROR: null,
        SET_FORM_VISIBILITY: null,
        SET_FORM_GROUP_VISIBILITY: null,
        SET_FORM_IS_MOBILE_RSVP: null,
        SET_LIMIT_ONE_ORDER_PER_EMAIL: null,
        SET_LIMIT_ONE_TICKET_TYPE_PER_EMAIL: null,
        SET_IS_ATTENDING: null,
        SET_FORM_INITIAL_VALUES: null,
        SET_IS_REGISTRATION_OPEN: null,
        SET_SESSIONS_STEP: false,
        SET_FORM_SESSIONS: null,
        SET_SELECTED_SESSIONS: null,
        TOGGLE_SELECTED_SESSION: null,
    },
    'formRenderer',
);
